import SelectColumn from 'components/SelectColumn';
import { useMemo } from 'react';

const PaymentMethodColumn = ({ record, isAdmin, canEdit, onPaymentMethodChange }) => {
  const currentMethod = record?.paymentMethod || '-';
  const onChangeAsync = useMemo(() => (newMethod) => onPaymentMethodChange(record, newMethod), [record, onPaymentMethodChange]);
  
  if (isAdmin && canEdit && record.Season?.playerRegFeeMandatory) {
    return (
      <SelectColumn
        value={currentMethod === '-' ? undefined : currentMethod}
        onChangeAsync={onChangeAsync}
        placeholder="Select method"
        className="payment-method-select"
        style={{ width: '100%' }}
        size="small"
        dropdownStyle={{ zIndex: 1000 }}
        options={[
          { value: 'CASH', label: 'CASH' },
          { value: 'COMGATE', label: 'COMGATE' },
          { value: undefined, label: '-' },
        ]}
      />
    );
  }
  
  return <span>{currentMethod}</span>;
};

export default PaymentMethodColumn;
